import React from 'react';
import styles from './style.module.scss';
import Arrow from './assets/arrow-left.svg';

interface PreviousQuestionArrowProps {
  onClick: () => void;
  isVisible: boolean;
}

const PreviousQuestionArrow: React.FC<PreviousQuestionArrowProps> = ({ onClick, isVisible }) => {

  if (!isVisible) return null;

  return (
    <div className={styles['previous-question-arrow']} onClick={onClick}>
      <img src={Arrow} alt={'previous arrow' }/>
    </div>
  );

};

export default PreviousQuestionArrow;
